'use strict';

define('LayoutDir',[],function () {
    function layoutDir($window, $location, $rootScope, $route, $timeout, $routeParams, GTMFac, LayoutFac, METADATA) {
        return {
            restrict: 'E',
            link: function (scope, elem) {

                var layout = "desktop",
                    subLayout = null,
                    body = angular.element(document.getElementById('angular-app'));

                scope.routeParams = $routeParams;
                scope.currentPage = $location.path().split('/')[1];


                scope.GTMEvents = function (section) {
                    var p = {};
                    p.gaEventCategory = 'Site Click';
                    p.gaEventAction = GTMFac.Tvg4ScreenName() + ' Page Click';
                    p.screenName = GTMFac.Tvg4ScreenName();

                    if (GTMFac.isTVG4()) {
                        p.sectionName = GTMFac.Tvg4SectionName();
                    }

                    if($routeParams.trackAbbr && $routeParams.raceNumber && METADATA.hasOwnProperty('allTracks') && METADATA.allTracks.hasOwnProperty($routeParams.trackAbbr) && METADATA.allTracks[$routeParams.trackAbbr].Name) {
                        p.trackName = METADATA.allTracks[$routeParams.trackAbbr].Name;
                        p.raceNumber = "R" + $routeParams.raceNumber;
                    }

                    GTMFac.GTMEvent().send($rootScope, 'siteClick', p);
                };

                scope.onResize = function () {
                    var calculatedLayout = LayoutFac.calculateLayout(scope.currentPage);
                    layout = calculatedLayout.layout;
                    subLayout = calculatedLayout.subLayout;

                    if (layout != scope.layout) {
                        body.addClass(layout);
                        scope.layout = layout;
                        scope.subLayout = subLayout;
                        $rootScope.layout = layout;
                        $rootScope.subLayout = subLayout;
                        if ($rootScope.raceInfoModal) {
                            $rootScope.raceInfoModal.close();
                            $rootScope.raceInfoModal = null;
                        }
                        _applyChanges();
                    } else if (subLayout != scope.subLayout) {
                        scope.subLayout = subLayout;
                        _applyChanges();
                    }


                    if ($window.CSS_LOADED === true) {
                        /*
                         Time to apply CSS
                         The app is already loading the modules in the background
                         because the $rootScope.layout is already defined
                         */
                        setTimeout(function () {
                            body.removeClass("loading");
                            body.removeClass("menu-expanded");
                            elem.removeClass("hidden");
                            $rootScope.apploaded = true;
                        }, 150);
                    } else {
                        scope.$watch(
                            function () {
                                return $window.CSS_LOADED;
                            }, function (currentValue) {
                                /*
                                 Time to apply CSS
                                 The app is already loading the modules in the background
                                 because the $rootScope.layout is already defined
                                 */
                                if (currentValue) {
                                    setTimeout(function () {
                                        body.removeClass("loading");
                                        body.removeClass("menu-expanded");
                                        elem.removeClass("hidden");
                                        $rootScope.apploaded = true;
                                    }, 150);
                                }
                            }
                        );
                    }
                };

                //CMS data is present when we boot the app
                scope.onResize();

                scope.goToHomePage = function () {
                    $location.path("/");
                };

                function _applyChanges() {
                    if (!_.isUndefined($rootScope.$$phase) &&
                        $rootScope.$$phase !== '$apply' &&
                        $rootScope.$$phase !== '$digest') {

                        scope.$apply();
                    }
                }
            }
        };
    }

    layoutDir.$inject = [
        '$window',
        '$location',
        '$rootScope',
        '$route',
        '$timeout',
        '$routeParams',
        'GTMFac',
        'LayoutFac',
        'METADATA'
    ];

    return layoutDir;
});

